export const addBidModalStyle = {
	wrapper: {},
	title: {
		textAlign: 'center',
		marginBottom: '40px',
	},

	bidValue: {
		fontWeight: 'bold',
	},

	bid: {
		display: 'flex',
		flexDirection: 'column',
		color: 'var(--neutral-300)',

		'&:first-child': {
			paddingRight: '231px',
			borderRight: '1px solid var(--neutral-100)',

			'@media (max-width: 767.98px)': {
				paddingRight: '150px',
			},

			'@media (max-width: 424.98px)': {
				paddingRight: '110px',
			},
		},
	},

	bidWrapper: {
		display: 'flex',
		gap: '16px',
		marginBottom: '24px',
	},

	search: {
		position: 'relative',

		svg: {
			position: 'absolute',
			left: '10px',
			top: '30px',
		},

		'& .MuiFormControl-root .MuiInputBase-root input': {
			width: '515px',
			paddingLeft: '40px',

			'&::placeholder': {
				color: 'var(--neutral-300)',
			},
		},
		'& .MuiFormControl-root .MuiInputBase-root fieldset': {
			background: 'transparent',
		},
	},

	bidIncrement: {
		marginTop: '12px',
	},
};
